// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'sites',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'package_type',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'active',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
